/**
 * useBreadcrumbSchema — inject un JSON-LD BreadcrumbList pour Rich Snippets
 * Google (breadcrumb dans les SERP). Améliore le CTR de ~30% selon Google.
 *
 * Usage :
 * ```ts
 * useBreadcrumbSchema([
 *   { name: "Accueil", url: "https://donoor.org" },
 *   { name: "Cagnotte en ligne", url: "https://donoor.org/cagnotte" },
 * ]);
 * ```
 */
export interface BreadcrumbItem {
  name: string;
  url: string;
}

export function useBreadcrumbSchema(items: BreadcrumbItem[]) {
  if (items.length < 2) return;

  useHead({
    script: [
      {
        type: "application/ld+json",
        innerHTML: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: items.map((item, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: item.name,
            item: item.url,
          })),
        }),
      },
    ],
  });
}
